export const pureWhite = "#FFFFFF";